var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardTemplateQrIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.833008,
    y: 0.700195,
    width: 31,
    height: 31,
    rx: 7.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.833008,
    y: 0.700195,
    width: 31,
    height: 31,
    rx: 7.5,
    stroke: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.25 -0.65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1884 2.9424C18.7423 2.49544 18.1492 2.24927 17.5181 2.24927H16.4521V2.03442C16.4521 1.4421 15.9703 0.960205 15.3779 0.960205H7.64356C7.05123 0.960205 6.56934 1.4421 6.56934 2.03442V2.24927H5.49954C4.19927 2.24927 3.14022 3.30828 3.13876 4.60993L3.1211 20.5943C3.12041 21.226 3.36563 21.8201 3.8116 22.2671C4.25762 22.714 4.8508 22.9602 5.48188 22.9602H17.5004C18.8007 22.9602 19.8598 21.9012 19.8612 20.5995L19.8789 4.61517C19.8796 3.9834 19.6344 3.38931 19.1884 2.9424ZM7.8584 2.24927H15.1631V3.53833H7.8584V2.24927ZM18.5735 20.5981C18.5728 21.1898 18.0915 21.6711 17.5004 21.6711H5.48188C5.19502 21.6711 4.9254 21.5593 4.72267 21.3561C4.51994 21.1529 4.40848 20.8829 4.40878 20.5958L4.42644 4.61139C4.42709 4.01967 4.90847 3.53833 5.49954 3.53833H6.56934V3.75317C6.56934 4.3455 7.05123 4.82739 7.64356 4.82739H15.3779C15.9703 4.82739 16.4521 4.3455 16.4521 3.75317V3.53833H17.5181C17.805 3.53833 18.0746 3.65022 18.2773 3.85338C18.4801 4.05653 18.5916 4.32659 18.5912 4.61371L18.5735 20.5981Z",
    fill: "#7F7F7F",
    transform: "translate(6.3 6.7) scale(0.85)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.719 9.55396H16.2982C16.6542 9.55396 16.9427 9.26538 16.9427 8.90942C16.9427 8.55347 16.6542 8.26489 16.2982 8.26489H11.719C11.363 8.26489 11.0745 8.55347 11.0745 8.90942C11.0745 9.26538 11.363 9.55396 11.719 9.55396Z",
    fill: "#7F7F7F",
    transform: "translate(6.3 6.7) scale(0.85)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.719 13.8508H16.2982C16.6542 13.8508 16.9427 13.5623 16.9427 13.2063C16.9427 12.8503 16.6542 12.5618 16.2982 12.5618H11.719C11.363 12.5618 11.0745 12.8503 11.0745 13.2063C11.0745 13.5623 11.363 13.8508 11.719 13.8508Z",
    fill: "#7F7F7F",
    transform: "translate(6.3 6.7) scale(0.85)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3167 16.8586H11.719C11.363 16.8586 11.0745 17.1472 11.0745 17.5032C11.0745 17.8591 11.363 18.1477 11.719 18.1477H16.3167C16.6726 18.1477 16.9612 17.8591 16.9612 17.5032C16.9612 17.1472 16.6726 16.8586 16.3167 16.8586Z",
    fill: "#7F7F7F",
    transform: "translate(6.3 6.7) scale(0.85)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.97593 7.15435L7.48955 8.64073L7.1391 8.29023C6.88739 8.03852 6.47931 8.03852 6.2276 8.29023C5.97589 8.5419 5.97589 8.95002 6.2276 9.20173L7.03382 10.008C7.1547 10.1289 7.31862 10.1968 7.48959 10.1968C7.66052 10.1968 7.82445 10.1289 7.94532 10.008L9.88747 8.06589C10.1392 7.81423 10.1392 7.40611 9.88747 7.1544C9.63575 6.90264 9.22768 6.90264 8.97593 7.15435Z",
    fill: "#7F7F7F",
    transform: "translate(6.3 6.7) scale(0.85)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.97593 11.7796L7.48955 13.2659L7.1391 12.9155C6.88739 12.6638 6.47931 12.6638 6.2276 12.9155C5.97589 13.1672 5.97589 13.5752 6.2276 13.827L7.03382 14.6332C7.1547 14.7541 7.31862 14.8221 7.48959 14.8221C7.66052 14.8221 7.82449 14.7542 7.94532 14.6332L9.88747 12.6911C10.1392 12.4394 10.1392 12.0313 9.88747 11.7796C9.63575 11.5279 9.22764 11.5279 8.97593 11.7796Z",
    fill: "#7F7F7F",
    transform: "translate(6.3 6.7) scale(0.85)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.97593 16.0764L7.48955 17.5628L7.1391 17.2124C6.88739 16.9607 6.47931 16.9607 6.2276 17.2124C5.97589 17.464 5.97589 17.8721 6.2276 18.1239L7.03382 18.9301C7.1547 19.051 7.31862 19.1189 7.48959 19.1189C7.66052 19.1189 7.82449 19.051 7.94532 18.9301L9.88747 16.988C10.1392 16.7363 10.1392 16.3282 9.88747 16.0765C9.63575 15.8248 9.22764 15.8248 8.97593 16.0764Z",
    fill: "#7F7F7F",
    transform: "translate(6.3 6.7) scale(0.85)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardTemplateQrIcon);
export default __webpack_public_path__ + "static/media/dashboard-template-qr-icon.bce6698ca0aab52cc126dc6cbf725d15.svg";
export { ForwardRef as ReactComponent };